import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check, Monitor, Smartphone } from "lucide-react";
import { THEMES } from "@/pages/preview/themes";
import AdminMock from "@/pages/preview/AdminMock";
import DriverMock from "@/pages/preview/DriverMock";

function useFonts() {
  useEffect(() => {
    const links = THEMES.map((t) => {
      const l = document.createElement("link");
      l.rel = "stylesheet"; l.href = t.fonts.url;
      document.head.appendChild(l);
      return l;
    });
    return () => { links.forEach((l) => l.remove()); };
  }, []);
}

function ThemeTabs({ cur, onPick }) {
  return (
    <div className="grid sm:grid-cols-3 gap-3" data-testid="design-switcher-bar">
      {THEMES.map((t, i) => (
        <button key={t.id} data-testid={`design-option-${t.id}`} onClick={() => onPick(i)}
          className={`text-right p-4 rounded-2xl border-2 bg-white transition-colors ${cur === i ? "border-slate-900 shadow-lg" : "border-slate-200 hover:border-slate-400"}`}>
          <div className="flex items-center justify-between"><b className="text-lg">التصميم {i + 1}: {t.name}</b>{cur === i && <Check className="w-5 h-5" />}</div>
          <div className="flex gap-1 my-2">{t.swatch.map((c) => <span key={c} className="w-7 h-7 rounded-full border border-black/10" style={{ background: c }} />)}</div>
          <p className="text-sm text-slate-500">{t.tagline}</p>
          <p className="text-xs text-slate-400 mt-1">الخط: {t.fonts.head} / {t.fonts.body}</p>
        </button>
      ))}
    </div>
  );
}

export default function DesignPreview() {
  useFonts();
  const [cur, setCur] = useState(0);
  const [view, setView] = useState("admin");
  const t = THEMES[cur];
  return (
    <div className="min-h-screen bg-slate-100 p-4 lg:p-8 space-y-5" data-testid="design-preview-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h1 className="text-2xl lg:text-3xl font-black">معاينة التصاميم الجديدة</h1><p className="text-slate-500 text-sm">معاينة فقط ببيانات توضيحية — لن يتغير شكل النظام حتى تختار التصميم</p></div>
        <Link to="/admin" data-testid="preview-back" className="btn btn-sm btn-ghost"><ArrowRight className="w-4 h-4" />العودة للنظام</Link>
      </div>
      <ThemeTabs cur={cur} onPick={setCur} />
      <div className="flex gap-2">
        {[["admin", "واجهة الإدارة", Monitor], ["driver", "واجهة السائق", Smartphone]].map(([k, l, I]) => (
          <button key={k} data-testid={`preview-view-${k}`} onClick={() => setView(k)} className={`btn btn-sm ${view === k ? "btn-dark" : "btn-ghost"}`}><I className="w-4 h-4" />{l}</button>
        ))}
      </div>
      <div key={t.id + view} className="fade-up" style={{ "--pv-head": `'${t.fonts.head}', sans-serif`, fontFamily: `'${t.fonts.body}', sans-serif` }}>
        {view === "admin" ? <AdminMock t={t} /> : <DriverMock t={t} />}
      </div>
    </div>
  );
}
